import { IProfileResponse, IUpdateProfileDTO, staticProfileEndpoints } from '@/models/profile.model';
import { ApiResponse, httpClient } from '@/utils';

class ProfileAPI {
  static getProfile(): ApiResponse<IProfileResponse> {
    const { GET_PROFILE } = staticProfileEndpoints;
    return httpClient.get<IProfileResponse>(GET_PROFILE);
  }

  static updateProfile(data: IUpdateProfileDTO): ApiResponse<IProfileResponse> {
    const { UPDATE_PROFILE } = staticProfileEndpoints;
    return httpClient.post<IProfileResponse>(UPDATE_PROFILE, data);
  }
}

export default ProfileAPI;
